export default __webpack_public_path__ + "static/media/gallery-4-2.5708a1fb.jpg";